module.exports = __webpack_public_path__ + "static/img/Carlton.909b089.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Carlton.jpg
// module id = 3Ie8
// module chunks = 1